import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';
// @mui
import { Avatar, Button, DialogContent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// components
import { ServerUtils } from '../../../api_utils';
import Iconify from '../../../components/Iconify';
import { DialogAnimate } from '../../../components/animate';
import { PATH_DASHBOARD } from '../../../routes/paths';

// ----------------------------------------------------------------------

const RowStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: theme.spacing(1.5),
}));

// ----------------------------------------------------------------------

ChatRoomPopup.propTypes = {
  participant: PropTypes.object,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

export default function ChatRoomPopup({ participant, isOpen, onClose }) {
  const { id, name, imageUrl, address, phone, username } = participant;
  const navigate = useNavigate()

  return (
    <DialogAnimate fullWidth maxWidth="xs" open={isOpen} onClose={onClose}>
      <DialogContent sx={{ pb: 5, textAlign: 'center' }}>
        <Avatar
          alt={name}
          src={ServerUtils.getUserImageUrl(participant)}
          sx={{
            mt: 5,
            mb: 2,
            mx: 'auto',
            width: 96,
            height: 96,
          }}
        />
        <Typography variant="h6">{name}</Typography>
        <RowStyle>
          <Iconify icon={'eva:email-fill'} sx={{ mr: 1, width: 16, height: 16, color: 'text.disabled' }} />
          <Typography variant="body2">{username}</Typography>
        </RowStyle>
        <RowStyle>
          <Button variant='contained' onClick={() => {
            onClose();
            navigate(`${PATH_DASHBOARD.user.root}/${id}`)
          }}>View Profile</Button>
        </RowStyle>
      </DialogContent>
    </DialogAnimate>
  );
}
